import { useState } from "react";
import { Download, KeyRound, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export function ExportDialog({ tenant, open, onClose }) {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  if (!tenant) return null;
  const run = async () => {
    setBusy(true);
    try { const r = await api.post(`/superadmin/tenants/${tenant.id}/export`); setRes(r.data); toast.success("Archivio cifrato pronto"); }
    catch (e) { toast.error(e.response?.data?.detail || "Esportazione non riuscita"); } finally { setBusy(false); }
  };
  const download = async () => {
    try {
      const r = await api.get(res.download_path.replace(/^\/api/, ""), { responseType: "blob" });
      const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = `export_${tenant.id}.zip`; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      toast.success("Download avviato (link monouso consumato)");
    } catch (e) { toast.error(e.response?.status === 410 ? "Link scaduto o già utilizzato" : "Download non riuscito"); }
  };
  const close = () => { setRes(null); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-lg" data-testid="export-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-[#2F7D32]" /> Esporta dati di «{tenant.name}»</DialogTitle></DialogHeader>
        {!res ? (
          <div className="space-y-2 text-sm text-slate-600">
            <p>Crea un archivio ZIP <b>cifrato AES-256</b> con contatti, consensi e storico, conversazioni, campagne, automazioni, liste/cluster, log import e allegati disponibili (JSON + CSV + manifest con SHA-256). Nessun token o credenziale viene incluso. I dati originali non vengono modificati.</p>
            <p className="text-xs text-slate-500">La password viene mostrata <b>una sola volta</b>; il link di download è monouso e scade dopo 24 ore.</p>
          </div>
        ) : (
          <div className="space-y-3 text-sm">
            <div className="rounded-lg border border-amber-300 bg-amber-50 p-3">
              <p className="text-xs text-amber-800 flex items-center gap-1 mb-1"><KeyRound className="h-3.5 w-3.5" /> Password dell'archivio — copiala ora, non verrà più mostrata</p>
              <code className="block font-mono text-sm break-all select-all" data-testid="export-password">{res.password}</code>
            </div>
            <div className="grid grid-cols-2 gap-1 text-xs text-slate-700" data-testid="export-summary">
              {Object.entries(res.record).map(([k, v]) => <span key={k}>{k}: <b>{v}</b></span>)}
            </div>
            <p className="text-xs text-slate-500">Dimensione {(res.size / 1024).toFixed(1)} KB · SHA-256 {res.sha256.slice(0, 16)}… · scade {res.expires_at.slice(0, 16).replace("T", " ")} UTC{res.non_esportabili?.length ? ` · ${res.non_esportabili.length} elementi non esportabili (vedi manifest)` : ""}</p>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="export-close">Chiudi</Button>
          {!res ? <Button disabled={busy} onClick={run} className="bg-[#2F7D32] text-white" data-testid="export-run">{busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <ShieldCheck className="h-4 w-4 mr-1" />} Genera archivio cifrato</Button>
            : <Button onClick={download} className="bg-[#2F7D32] text-white" data-testid="export-download"><Download className="h-4 w-4 mr-1" /> Scarica ZIP (monouso)</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
